
import React, { useEffect, useState } from 'react';
import { getregister, getsavedprofiles, getcaste, deletewishlist } from "../action/user";
import { useLocation } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import FavoriteIcon from '@mui/icons-material/Favorite';
import config from "../../lib/config";
import whyeliteRight from "../../assests/images/whyelite-right.png";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Freesearch() {

    const notify = () => toast("Removed Successfully!");
    const [registerfilter, setRegisterfilters] = useState([]);

    const search = useLocation().search;
    const [searchparamsf, setsearchparamsf] = useState(search);

    // console.log("fresdrw",search)
    var filterobj = "status=1";
    const castename = new URLSearchParams(search).get('castename');
    if (castename) {
        filterobj += "&castename=" + castename;
    }
    const religion = new URLSearchParams(search).get('religion');
    if (religion) {
        filterobj += "&religion=" + religion;
    }
    const subcaste = new URLSearchParams(search).get('subcaste');
    if (subcaste) {
        filterobj += "&subcaste=" + subcaste;
    }
    const sex = new URLSearchParams(search).get('sex');
    if (sex) {
        filterobj += "&sex=" + sex;
    }
    const maritalname = new URLSearchParams(search).get('maritalname');
    if (maritalname) {
        filterobj += "&maritalname=" + maritalname;
    }

    const c_date = new Date();
    let year = c_date.getFullYear();
    const age1 = new URLSearchParams(search).get('age1');
    if (age1) {
        const g_year = year - age1;

        filterobj += "&year[$lte]=" + g_year;
    }

    const age2 = new URLSearchParams(search).get('age2');
    if (age2) {
        const l_year = year - age2;

        filterobj += "&year[$gte]=" + l_year;
    }

    // var filterarray="religion="+religion+"&subcaste="+subcaste+"&castename="+castename+"&sex="+sex+"&maritalname="+maritalname;


    // const subcaste = new URLSearchParams(search).get('subcaste');
    // const sex = new URLSearchParams(search).get('sex');
    // const maritalname = new URLSearchParams(search).get('maritalname');
    const [castes, setCastes] = useState([]);

    const getUserData = async () => {

        // console.log("fghjfghjfghjgjhgfjhgdfjhgdfsjhgdjdjhg");
        var test = await getsavedprofiles();

        //   console.log(test, "solo");
        setRegisterfilters(test.userValue.map(e => e.wishlists));


    }
    useEffect(() => {
        //logout(history)
        getUserData();
    }, []);
    const initialFormValue = {

        sex: "",

    };
    const [formValue, setFormValue] = useState(initialFormValue);
    const [width, setWidth] = useState(window.innerWidth);
    const [height1, setHeight] = useState(window.innerHeight);
    const sexch = [
        { title: "Male", value: "Male" },
        { title: "Female", value: "Female" },
    ];
    const ondeletewish = async (id) => {
        try {
            await deletewishlist(id);
            var test = await getsavedprofiles();
            setRegisterfilters(test.userValue.map(e => e.wishlists));
            notify();
        } catch (error) {
            console.error("Error deleting wishlist:", error);
        }
    }


    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }
    useEffect(() => {

        // console.log(width);

        // console.log(height1);
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    });

    const occupations = [
        { title: "CxO / Chairman / Director / President", value: "CxO / Chairman / Director / President" },
        { title: "VP / AVP / GM / DGM", value: "VP / AVP / GM / DGM" },
        { title: "Sr. Manager / Manager", value: "Sr. Manager / Manager" },
        { title: "Consultant / Supervisor / Team Leads", value: "Consultant / Supervisor / Team Leads" },
        { title: "Team Member / Staff", value: "Team Member / Staff" },

        { title: "Air Hostess / Flight Attendant", value: "Air Hostess / Flight Attendant" },
        { title: "Pilot / Co-Pilot", value: "Pilot / Co-Pilot" },

        { title: "Architect", value: "Architect" },
        { title: "Interior Designer", value: "Interior Designer" },
        { title: "Landscape Architect", value: "Landscape Architect" },

        { title: "Animator", value: "Animator" },
        { title: "Commercial Artist", value: "Commercial Artist" },
        { title: "Web / UX Designers", value: "Web / UX Designers" },

        { title: "Beautician", value: "Beautician" },
        { title: "Fashion Designer", value: "Fashion Designer" },
        { title: "Hairstylist", value: "Hairstylist" },
        { title: "Jewellery Designer", value: "Jewellery Designer" },

        { title: "Customer Support / BPO / KPO Professional", value: "Customer Support / BPO / KPO Professional" },

        { title: "IAS / IRS / IES / IFS", value: "IAS / IRS / IES / IFS" },
        { title: "Indian Police Services [IPS]", value: "Indian Police Services [IPS]" },

        { title: "Airforce", value: "Airforce" },
        { title: "Army", value: "Army" },
        { title: "Navy", value: "Navy" },

        { title: "Lecturer", value: "Lecturer" },
        { title: "Professor", value: "Professor" },
        { title: "Research Assistant", value: "Research Assistant" },
        { title: "Research Scholar", value: "Research Scholar" },
        { title: "Teacher", value: "Teacher" },

        { title: "Civil Engineer", value: "Civil Engineer" },
        { title: "Electronics / Telecom Engineer", value: "Electronics / Telecom Engineer" },
        { title: "Mechanical / Production Engineer", value: "Mechanical / Production Engineer" },

        { title: "Chef / Sommelier / Food Critic", value: "Chef / Sommelier / Food Critic" },
        { title: "Catering Professional", value: "Catering Professional" },

        { title: "Software Developer / Programmer", value: "Software Developer / Programmer" },
        { title: "Software Consultant", value: "Software Consultant" },
        { title: "Hardware & Networking professional", value: "Hardware & Networking professional" },

        { title: "Lawyer", value: "Lawyer" },
        { title: "Legal Assistant", value: "Legal Assistant" },

        { title: "Dentist", value: "Dentist" },
        { title: "Doctor", value: "Doctor" },
        { title: "Medical Transcriptionist", value: "Medical Transcriptionist" },
        { title: "Nurse", value: "Nurse" },
        { title: "Pharmacist", value: "Pharmacist" },
        { title: "Physician Assistant", value: "Physician Assistant" },
        { title: "Physiotherapist / Occupational Therapist", value: "Physiotherapist / Occupational Therapist" },
        { title: "Psychologist", value: "Psychologist" },
        { title: "Surgeon", value: "Surgeon" },
        { title: "Veterinary Doctor", value: "Veterinary Doctor" },

        { title: "Merchant Naval Officer", value: "Merchant Naval Officer" },
        { title: "Mariner", value: "Mariner" },

        { title: "Marketing Professional", value: "Marketing Professional" },
        { title: "Sales Professional", value: "Sales Professional" },

        { title: "Biologist / Botanist", value: "Biologist / Botanist" },
        { title: "Physicist", value: "Physicist" },
        { title: "No Job", value: "No Job" },
        { title: "Others", value: "Others" },
    ];

    const educationOptions = [
        { title: "High School", value: "High School" },
        { title: "Higher Secondary", value: "Higher Secondary" },
        { title: "Diploma", value: "Diploma" },
        { title: "Bachelor's Degree", value: "Bachelor's Degree" },
        { title: "Master's Degree", value: "Master's Degree" },
        { title: "MBA", value: "MBA" },
        { title: "MCA", value: "MCA" },
        { title: "B.Tech", value: "B.Tech" },
        { title: "M.Tech", value: "M.Tech" },
        { title: "MBBS", value: "MBBS" },
        { title: "MD", value: "MD" },
        { title: "PhD", value: "PhD" },
        { title: "CA (Chartered Accountant)", value: "CA" },
        { title: "CS (Company Secretary)", value: "CS" },
        { title: "ICWA", value: "ICWA" },
        { title: "LLB", value: "LLB" },
        { title: "LLM", value: "LLM" },
        { title: "B.Arch", value: "B.Arch" },
        { title: "M.Arch", value: "M.Arch" },
        { title: "B.Sc", value: "B.Sc" },
        { title: "M.Sc", value: "M.Sc" },
        { title: "B.Com", value: "B.Com" },
        { title: "M.Com", value: "M.Com" },
        { title: "BA", value: "BA" },
        { title: "MA", value: "MA" },
        { title: "BBA", value: "BBA" },
        { title: "BCA", value: "BCA" },
        { title: "Others", value: "Others" },
    ];

    return (
        <>
            <div className="container">
                <div className="text-center" style={{ marginTop: '20px', marginBottom: '80px' }}>
                    <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                        {/* <div className="col-md-12 prink" style={{ marginTop: '35px' }}>
                            <div className="row">
                             
                            </div>
                        </div> */}
                        {registerfilter?.length ? registerfilter.map(post => (
                            <div className="col-md-12 search-result" style={{ marginTop: '35px' }}>
                                <div className="title row">
                                    <div className="col-md-6" style={{ paddingLeft: 'unset', fontSize: '15px' }}>
                                        <p className='name' style={{ fontSize: "16px" }}>TMM-70522 <span style={{ fontSize: "18px" }}> - {post.mname}</span></p>
                                    </div>
                                    <div className="col-md-6" style={{ paddingRight: 'unset', fontSize: '15px' }}>
                                        <a href={"/batman/" + post._id} className='buttonsss'>View Profile</a>
                                        <button onClick={() => ondeletewish(post._id)} className='drink'>Remove</button>
                                    </div>

                                </div>
                                <hr style={{ marginTop: '-10.1px' }} />
                                <div className="row">
                                    <div className="col-md-2">
                                        <img src={Array.isArray(post.photopath) && post.photopath.length && post.photopath[0] ? config.API + "/images/user/" + post.photopath : post.sex == "Male" ? require('../../assests/images/man.png') : require('../../assests/images/woman.png')} alt="Profile" className="img-responsive frog" style={{ height: "200px" }} />
                                    </div>
                                    <div className="col-md-5 content">

                                        <table className='Droid Sans' style={{ width: '80%', fontSize: '15px', fontFamily: 'fantasy' }}>

                                            <tbody>

                                                <tr>
                                                    <td style={{ color: '#b21919', textAlign: 'left', paddingBottom: "10px" }}><b>Gender </b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}> {post.sex}</td>
                                                </tr>

                                                <tr>
                                                    <td style={{ color: '#b21919', textAlign: 'left', paddingBottom: "10px" }}><b>Age</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}>{post.age = new Date().getFullYear() - post.year + "" + "Yrs"}</td>
                                                </tr>
                                                {/* <tr>
                                                    <td style={{ color: '#b21919', textAlign: 'left', paddingBottom: "10px" }}><b>Date of birth</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}> {post.dob = post.date + "-" + post.month + "-" + post.year}</td>
                                                </tr>

                                                <tr>
                                                    <td style={{ color: '#b21919', textAlign: 'left', paddingBottom: "10px" }}><b>Father's name</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', marginLeft: '10px', paddingBottom: "10px" }}>{post.father_name}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ color: '#b21919', textAlign: 'left', paddingBottom: "10px" }}><b>Mother's name</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}>{post.mother_name}</td>
                                                </tr> */}

                                                <tr>
                                                    <td style={{ color: '#b21919', textAlign: 'left', paddingBottom: "10px" }}><b>Religion</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}>{post.religion}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ color: '#b21919', textAlign: 'left', paddingBottom: "10px" }}><b>Caste</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}>{post.castename}</td>
                                                </tr>
                                                {/* <tr>
                                            <td style={{ color: '#b21919', textAlign: 'left', paddingBottom:"10px" }}><b>நட்சத்திரம் </b></td>
                                            <td style={{ width: '22px' , paddingBottom:"10px"}}>:</td>
                                            <td style={{ textAlign: 'left', paddingBottom:"10px" }}> {post.starname}</td>
                                        </tr> */}
                                            </tbody>
                                        </table>

                                    </div>
                                    <div className="col-md-5 content">
                                        <table style={{ width: '80%', fontSize: '15px' }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ color: '#b21919', textAlign: 'left', paddingBottom: "10px" }}><b>Job</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}>{post.occup && (occupations.some(item => item.title === post?.occup) ? post?.occup : post?.occup + " (Others)")}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ color: '#b21919', textAlign: 'left', paddingBottom: "10px" }}><b>Education</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}>{post.educ && (educationOptions.some(item => item.title === post?.educ) ? post?.educ : post?.educ + " (Others)")}</td>
                                                </tr>
                                                {/* <tr>
                                                    <td style={{ color: '#b21919', textAlign: 'left', paddingBottom: "10px" }}><b>Height</b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}>{post.height}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ color: '#b21919', textAlign: 'left', paddingBottom: "10px" }}><b>City </b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}> {post.city} </td>
                                                </tr> */}
                                                <tr>
                                                    <td style={{ color: '#b21919', textAlign: 'left', paddingBottom: "10px" }}><b>Sub Caste </b></td>
                                                    <td style={{ width: '22px', paddingBottom: "10px" }}>:</td>
                                                    <td className='treatzz' style={{ textAlign: 'left', paddingBottom: "10px" }}> {post.subcaste}</td>
                                                </tr>

                                            </tbody>
                                        </table>
                                        <div class="topright-hide" style={{ textAlign: 'right' }}>
                                            <img src={whyeliteRight} class="whyelite-bottom" alt="Elite Arrow"
                                                style={{ width: '21%', marginTop: '-35px', marginRight: '-8px' }}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>

                        )) : <div class="empty-state__content">
                            <div class="empty-state__icon">
                                <img src={require('../../assests/img/norec.png')} alt="" />
                            </div>
                            <div class="empty-state__message">No Profiles Found.</div>
                        </div>}
                    </div></div>
            </div>







        </>
    )
}

export default Freesearch;
